import { MIN_PARENT_ASSET_LOADING_THRESHOLD } from '../constants';
export const loadDependentScript = (scriptCb, scriptLoadTimeout = MIN_PARENT_ASSET_LOADING_THRESHOLD) => {
  let loadDependentScriptInterval = null;
  let tries = 0;
  const startTime = Date.now();
  loadDependentScriptInterval = setInterval(() => {
    if (document.readyState === 'complete' && Date.now() - startTime > scriptLoadTimeout && tries < 1) {
      tries++;
      if (loadDependentScriptInterval) {
        clearInterval(loadDependentScriptInterval);
      }
      scriptCb();
    }
  }, 250);
};